import { SearchKeyInputItems } from '../../component/form/search-key-input.component';
import i18n from '../../i18n';

/** 风险订单列表筛选项配置 */
export type RiskOrderListFilterItemsOptions = {
    /** 是否包含处理状态筛选（仅云端历史列表需要） */
    includeStatus?: boolean;
    /**
     * 订单号筛选项的 SearchKeyInput key / 接口查询参数名
     * - 即时列表：前端按行字段 `order_head_id` 过滤，默认 `order_head_id`
     * - 云端列表：接口 Query 为 `order_no`，传 `order_no`
     */
    orderNumberKey?: 'order_head_id' | 'order_no';
};

/** 处理状态筛选项：与 risk_order.risk_status 一致，云端请求参数 key 为 status */
const STATUS_FILTER_ITEM: SearchKeyInputItems = {
    value: 'status',
    label: i18n.t('restaurant_info_page_status'),
    type: 'SELECT',
    options: [
        { value: '0', label: i18n.t('intelligent_risk_control_page_status_pending') },
        { value: '1', label: i18n.t('intelligent_risk_control_page_status_ignored') },
        { value: '2', label: i18n.t('intelligent_risk_control_page_status_resolved') },
    ],
};

/**
 * 风险订单列表高级筛选字段（SearchKeyInput items）
 * @param options.includeStatus - 即时列表为 false；云端列表为 true
 */
export function getRiskOrderListFilterItems(options?: RiskOrderListFilterItemsOptions): SearchKeyInputItems[] {
    // 订单号筛选字段名：云端走 order_no，即时列表走 order_head_id
    const orderNumberKey = options?.orderNumberKey ?? 'order_head_id';
    const items: SearchKeyInputItems[] = [
        {
            value: 'risk_tag',
            label: i18n.t('intelligent_risk_control_page_filter_risk_tag'),
            type: 'SELECT',
            options: [
                { value: '1', label: i18n.t('intelligent_risk_control_page_risk_tag_max_discount_amount') },
                { value: '2', label: i18n.t('intelligent_risk_control_page_risk_tag_max_refund_count') },
                { value: '3', label: i18n.t('intelligent_risk_control_page_risk_tag_max_refund_amount') },
                { value: '4', label: i18n.t('intelligent_risk_control_page_risk_tag_avg_dish_count_abnormal') },
                { value: '5', label: i18n.t('intelligent_risk_control_page_risk_tag_max_dining_duration_abnormal') },
                { value: '6', label: i18n.t('intelligent_risk_control_page_event_type_fast_close') },
                { value: '7', label: i18n.t('intelligent_risk_control_page_event_type_cancel') },
            ],
        },
        {
            value: orderNumberKey,
            label: i18n.t('business_analysis_page_order_account'),
            type: 'TEXT',
        },
        {
            value: 'operator_name',
            label: i18n.t('intelligent_risk_control_page_column_server'),
            type: 'TEXT',
        },
        {
            value: 'table_name',
            label: i18n.t('intelligent_risk_control_page_filter_table'),
            type: 'TEXT',
        },
    ];

    if (options?.includeStatus) {
        return [items[0], STATUS_FILTER_ITEM, ...items.slice(1)];
    }
    return items;
}
